export default __webpack_public_path__ + "img/414be22786f45a0f754421b8e942e2d4.svg";